import script from "./InscriptionAndBankDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./InscriptionAndBankDetails.vue?vue&type=script&setup=true&lang=js"

import "./InscriptionAndBankDetails.vue?vue&type=style&index=0&id=f764bcec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f764bcec"]])

export default __exports__